import { css } from '@emotion/react';
import { flex } from '../../styles/utils';
import { ZeeFontBold, ZeeFontMedium, ZeeFontRegular } from '../../styles/font';
import { MediaBP as MQ } from '../../styles/mediaQuery';
import { colors } from '../../styles/colors';

export const mainContainer = css``;
export const heading = css`
  text-align: left;
  margin: 24px 16px 0px 16px;
  ${ZeeFontBold(16, 22)};
  color: ${colors.PrimaryWhiteColor};
`;
export const textField = css`
  position: relative;
  background: #1d1425;
`;
export const submitButton = css`
  height: 48px;
  margin: 0 16px;
  color: ${colors.PrimaryWhiteColor};
  background: ${colors.Purple};
  border: none;
  border-radius: 6px;
  cursor: pointer;
  width: calc(100% - 32px);
  &:disabled {
    opacity: 0.5;
    color: ${colors.AccentInfoPopupDescriptionMobileColor};
    pointer-events: none;
  }
`;
export const fullName = css`
  height: 48px;
  border: 1px solid #786d80;
  border-radius: 6px;
  margin: 16px;
  width: calc(100% - 32px);
  background: #1d1425;
  color: ${colors.PrimaryWhiteColor};
  padding-left: 4%;
  ${MQ.MediaSm} {
    padding-left: 2.5%;
  }

  &:valid {
    border: 1px solid #8230c6;
    border-radius: 8px;
  }

  &:focus {
    border: 1px solid #8230c6;
    border-radius: 8px;
  }
  &:focus-visible {
    outline: none;
  }
`;
export const buttonText = css`
  height: 20px;
  ${ZeeFontMedium(14, 20)};
  margin: 0px auto;
  ${MQ.MediaSm} {
    ${ZeeFontBold(16, 22)};
  }
`;
